// src/shell/nav.js
// Navigation structure — single source of truth.
//
// Two navigation systems with distinct jobs:
//   Bottom nav  = permanent app navigation (Home/Neighborhood/Resources/More)
//   Top subnav  = contextual modes within the emergency experience (Command/Map/Travel)
//
// Command is NOT in the bottom nav — it lives in the top subnav.
// Home is the everyday starting point; Command is the emergency intelligence layer.

// ── Bottom navigation ─────────────────────────────────────────────
export const NAV = [
  {
    id: 'home',
    label: 'HOME',
    emoji: '🏠',
    color: '#d97706',
    defaultPath: '/feed',
    tabs: [
      { id: 'feed', label: 'Situation', emoji: '📋', path: '/feed' },
      { id: 'news', label: 'Alerts',    emoji: '📰', path: '/news' },
    ],
  },
  {
    id: 'neighborhood',
    label: 'MY NEIGHBORHOOD',
    emoji: '🏡',
    color: '#059669',
    defaultPath: '/neighborhood',
    tabs: [
      { id: 'neighborhood', label: 'My Neighborhood', emoji: '🏡', path: '/neighborhood' },
    ],
  },
  {
    id: 'resources',
    label: 'RESOURCES',
    emoji: '⛽',
    color: '#059669',
    defaultPath: '/resources',
    tabs: [
      { id: 'resources', label: 'Find Help', emoji: '⛽', path: '/resources' },
      { id: 'tools',     label: 'Tools',     emoji: '🛠',  path: '/tools' },
    ],
  },
  {
    id: 'command',
    label: 'COMMAND',
    emoji: '🛰',
    color: '#0369a1',
    defaultPath: '/command',
    tabs: [
      { id: 'command', label: 'Command', emoji: '🛰', path: '/command' },
      { id: 'map',     label: 'Map',     emoji: '🗺', path: '/map'     },
      { id: 'travel',  label: 'Travel',  emoji: '🚗', path: '/travel'  },
    ],
  },
  {
    id: 'more',
    label: 'MORE',
    emoji: '•••',
    color: '#6b7280',
    defaultPath: '/more',
    tabs: [
      { id: 'more', label: 'More', emoji: '•••', path: '/more' },
    ],
  },
];

// ── Command paths — for SubNav detection ─────────────────────────
export const COMMAND_TABS = NAV.find(m => m.id === 'command')?.tabs ?? [];
export const COMMAND_PATHS = new Set(COMMAND_TABS.map(t => t.path));

// Flat path → bottom nav mode lookup
// Command paths also map to command mode so SubNav stays visible
export const PATH_TO_MODE = Object.fromEntries([
  ...NAV.flatMap((m) => m.tabs.map((t) => [t.path, m.id])),
  ['/map', 'command'], ['/travel', 'command'],
]);

// Paths that suppress the SubNav strip
export const NO_SUBNAV_PATHS = ['/more', '/medical', '/checkin', '/alerts', '/gps', '/legal', '/admin'];
